module.exports = __webpack_public_path__ + "img/柚子3.8b7b8971.png";